export function GetAllReportTypes() {
  return ["Summary", "Summary by Theme", "Monthly", "Daily"];
}

export function GetMRLCReportTypes() {
  return ["Summary", "Monthly", "Daily"];
}

export function GetLogSources() {
  return ["All", "FTP", "GDA", "EROS", "RockyWeb", "S3"];
}

export function GetFileTypes() {
  return [
    "All",
    "7Z",
    "AUX",
    "CPG",
    "DB",
    "DBF",
    "GBD",
    "GPKG",
    "GZ",
    "JP2",
    "LAS",
    "LAZ",
    "MSK",
    "PDF",
    "PRJ",
    "SBN",
    "SBX",
    "SHP",
    "SHX",
    "TFW",
    "TIF",
    "TMP",
    "TXT",
    "VRT",
    "XML",
    "ZIP",
  ];
}

export function GetResponseCodes() {
  return [
    "All",
    "200 - OK",
    "206 - Partial Content",
    "301 - Moved Permanently",
    "302 - Found",
    "304 - Not Modified",
    "400 - Bad Request",
    "403 - Forbidden",
    "404 - Not Found",
    "405 - Method Not Allowed",
    "500 - Internal Server Error",
    "503 - Service Unavailable",
  ];
}

export function GetDownloadThemes() {
  return [
    "All",
    "Contours",
    "Elevation",
    "GovtUnit",
    "Hydrography",
    "Imagery",
    "Woodland Tint",
    "Maps",
    "Map Indices",
    "GeographicNames",
    "Small-scale",
    "Structures",
    "Topo Map Vector Products",
    "Transportation",
    "Unclassified",
  ];
}

export function GetDownloadDatasets(theme) {
  const datasetOptions = {
    All: ["All"],
    Boundaries: ["All", "Boundaries"],
    Contours: ["All", "National", "Shape", "GDB"],
    Elevation: [
      "All",
      "Contours",
      "1",
      "1m",
      "13",
      "19",
      "2",
      "5 meter DEM",
      "DSM",
      "LPC",
      "OPR",
      "ORI",
      "Topobathy Lidar",
      "Unclassified",
    ],
    GovtUnit: ["All", "National", "Shape", "GDB"],
    Hydrography: ["All", "NHD", "NHDPlus", "WBD", "Unclassified"],
    Imagery: ["All", "NAIP", "NAIP HRO", "Unclassified"],
    "Woodland Tint": ["All", "National", "Shape", "GDB"],
    Maps: [
      "All",
      "US Topo",
      "Historical Topo",
      "OnDemand Topo",
      "Unclassified",
    ],
    "Map Indices": ["All", "National", "Shape", "GDB"],
    GeographicNames: [
      "All",
      "Antarctica",
      "Topical",
      "FullModel",
      "FederalCodes",
      "Archive",
      "GAZ",
    ],
    "Small-scale": [
      "All",
      "Data",
      "Metadata",
      "Small-scale Boundaries",
      "Small-scale Contours",
      "Small-scale Elevation",
      "Small-scale Hydrography",
      "Small-scale Land Cover",
      "Small-scale Names And Map Reference",
      "Small-scale Other",
      "Small-scale Structures",
      "Unclassified",
    ],
    Structures: ["All", "National", "Shape", "GDB"],
    Transportation: ["All", "National", "Shape", "GDB"],
    "Topo Map Vector Products": ["All", "Unclassified"],
    Vector: ["All", "Unclassified"],
    Unclassified: ["All", "Unclassified"],
  };

  let returnArray = [];
  if (datasetOptions[theme] && datasetOptions[theme].length > 0) {
    returnArray = datasetOptions[theme];
  }
  return returnArray;
}

export function GetBasemapThemes() {
  return [
    "All",
    "USGSTNMBlank",
    "USGSTopo",
    "USGSImageryTopo",
    "USGSImageryOnly",
    "USGSShadedReliefOnly",
    "USGSHydroCached",
  ];
}

export function GetBasemapInterfaceTypes() {
  return [
    "All",
    "Tile",
    "WMTS",
    "Export",
    "LayerOperation",
    "ServiceOperation",
    "Layers",
    "WMS",
    "Identify",
    "Other",
  ];
}

export function GetServiceThemes() {
  return [
    "All",
    "3DEPElevation",
    "3DEPElevationIndex",
    "3DEPSpecification",
    "3DHP_All",
    "Alaska_acquisition",
    "ArcticSDI_US",
    "Contours",
    "DynaMap_Index",
    "geonames",
    "govunits",
    "htLabels",
    "htOverlay",
    "map_indices",
    "nhd",
    "NHDPlus_HR",
    "NHDPlus_HR_Index",
    "Other",
    "Public3DEPAreasOfInterest",
    "selectable_polygons",
    "StreamGages_Linked_to_NHDPlus_2_1",
    "structures",
    "transportation",
    "USTopoAvailability",
    "USGSNAIPImagery",
    "USGSNAIPImageryIndex",
    "USGSNAIPPlus",
    "USGSPlannedOngoingLidar",
    "USGSProposed3DEP",
    "USGSImageryTopo",
    "USGSTrails",
    "Utilities",
  ];
}

export function GetServiceInterfaceTypes() {
  return [
    "All",
    "Export",
    "WMS",
    "WFS",
    "WCS",
    "Identify",
    "Tile",
    "WMTS",
    "Legend",
    "Query",
    "Other",
    "ServiceOperation",
    "GetSamples",
    "LayerOperation",
    "Histograms",
    "Projects",
    "Info",
    "Geometry",
    "Raster",
  ];
}

export function GetViewerThemes() {
  return [
    "All",
    "Apps",
    "Bulk PQS",
    "Datasets",
    "Downloader",
    "Download Manager",
    "Elevation",
    "EPQS",
    "Examples",
    "Help",
    "Launch",
    "LAZ",
    "Lidar Explorer",
    "Metadata Lineage Reporter",
    "Metrics",
    "Mobile",
    "Raster Conversion Tools",
    "Services",
    "Status",
    "TNMAccess API",
    "Uget Instructions",
    "Unclassified",
    "Viewer",
    "Viewer (Cesium)",
    "Viewer (PX3)",
  ];
}

export function GetMRLCThemes() {
  return ["All", "MRLC"];
}

export function GetFileTypesByDownloadsTheme(theme) {
  const themeOptions = {
    All: GetFileTypes(),
    Boundaries: ["All"],
    Contours: ["All", "DB", "TIF", "XML", "ZIP"],
    Elevation: [
      "All",
      "0",
      "0M",
      "3",
      "AUX",
      "BAT",
      "CPG",
      "DB",
      "DBF",
      "GMC",
      "GPKG",
      "HTML",
      "IMG",
      "LAS",
      "LAZ",
      "LNK",
      "MSK",
      "PDF",
      "PRJ",
      "SHP",
      "SHX",
      "TIF",
      "TMP",
      "TXT",
      "URL",
      "VRT",
      "XML",
      "ZIP",
    ],
    GovtUnit: ["All", "XML", "ZIP"],
    Hydrography: ["All", "7Z", "TMP", "XML", "ZIP"],
    Imagery: [
      "All",
      "DS_STORE",
      "AUX",
      "DBF",
      "J2I",
      "JP2",
      "PRJ",
      "SBN",
      "SBX",
      "SHP",
      "SHX",
      "TXT",
      "XML",
      "ZIP",
    ],
    "Woodland Tint": ["All", "XML", "ZIP"],
    Maps: ["All", "DB", "ICO", "PDF", "TIF", "TFW", "TXT", "ZIP"],
    "Map Indices": ["All", "XML", "ZIP"],
    GeographicNames: ["All", "GAZ", "JPG", "XML", "ZIP"],
    "Small-scale": ["All", "GZ", "XML"],
    Structures: ["All", "XML", "ZIP"],
    "Topo Map Vector Products": ["All", "0", "1", "C", "H", "XML", "ZIP"],
    Transportation: ["All", "1", "DB", "XML", "ZIP"],
    Vector: ["All"],
    Woodland: ["All"],
    Unclassified: ["All", "ZIP"],
  };

  return themeOptions[theme] || [];
}

export function GetFileTypesByDownloadsDataset(theme, dataset) {
  const datasetOptions = {
    All: GetFileTypesByDownloadsTheme(theme),
    Boundaries: [
      {
        Boundaries: ["All"],
      },
    ],
    Contours: {
      National: ["All", "ZIP", "XML"],
      Shape: ["All", "ZIP", "DB", "XML", "TIF"],
      GDB: ["All", "ZIP", "XML"],
    },
    Elevation: {
      Contours: ["All"],
      1: ["All", "AUX", "DB", "GPKG", "MSK", "TIF", "TXT", "VRT", "XML"],
      "1m": ["All", "AUX", "MSK", "TIF", "TXT", "XML", "ZIP"],
      13: ["All", "TIF", "XML", "GPKG", "DB", "AUX", "TXT", "VRT"],
      19: [
        "All",
        "CPG",
        "DBF",
        "PRJ",
        "SBN",
        "SBX",
        "SHP",
        "SHX",
        "TXT",
        "ZIP",
      ],
      2: ["All", "DB", "GPKG", "TIF", "TXT", "VRT", "XML"],
      "5 meter DEM": ["All"],
      DSM: ["All", "CPG", "DB", "GPKG", "TXT", "XML", "ZIP"],
      LPC: ["All", "GPKG", "LAS", "LAZ", "TIF", "TXT", "XML", "ZIP"],
      OPR: [
        "All",
        "O",
        "0M",
        "3",
        "BAT",
        "CPG",
        "DB",
        "DBF",
        "GMC",
        "GPKG",
        "HTML",
        "IMG",
        "LNK",
        "PDF",
        "PRJ",
        "SHP",
        "SHX",
        "TIF",
        "TMP",
        "TXT",
        "URL",
        "XML",
        "ZIP",
      ],
      ORI: ["All", "DB", "GPKG", "TXT", "XML", "ZIP"],
      "Topobathy Lidar": ["All"],
    },
    GovtUnit: {
      National: ["All", "XML", "ZIP"],
      Shape: ["All", "XML", "ZIP"],
      GDB: ["All", "XML", "ZIP"],
    },
    Hydrography: {
      NHD: ["All", "TMP", "XML", "ZIP"],
      NHDPlus: ["All", "7Z", "XML", "ZIP"],
      WBD: ["All", "XML", "ZIP"],
    },
    Imagery: {
      NAIP: [
        "All",
        "DS_STORE",
        "AUX",
        "DBF",
        "J2I",
        "JP2",
        "PRJ",
        "SBN",
        "SBX",
        "SHP",
        "SHX",
        "TXT",
        "XML",
        "ZIP",
      ],
      "NAIP HRO": ["All", "XML", "ZIP"],
    },
    WoodlandTint: {
      National: ["All", "XML", "ZIP"],
      Shape: ["All", "XML", "ZIP"],
      GDB: ["All", "XML", "ZIP"],
    },
    Maps: {
      "US Topo": ["All", "ICO", "PDF", "TXT"],
      "Historical Topo": ["All", "DB", "PDF", "TIF", "TFW", "ICO", "TXT"],
      "OnDemand Topo": ["All", "PDF", "ZIP", "TIF"],
    },
    "Map Indices": {
      National: ["All", "XML", "ZIP"],
      Shape: ["All", "XML", "ZIP"],
      GDB: ["All", "XML", "ZIP"],
    },
    GeographicNames: {
      Antarctica: ["All", "GAZ", "JPG", "XML", "ZIP"],
      Topical: ["All", "GAZ", "JPG", "XML", "ZIP"],
      FullModel: ["All", "GAZ", "JPG", "XML", "ZIP"],
      FederalCodes: ["All", "GAZ", "JPG", "XML", "ZIP"],
      Archives: ["All", "GAZ", "JPG", "XML", "ZIP"],
    },
    "Small-scale": {
      Data: ["All", "GZ"],
      Metadata: ["All", "XML"],
      "Small-scale Boundaries": ["All"],
      "Small-scale Contours": ["All"],
      "Small-scale Elevation": ["All"],
      "Small-scale Hydrography": ["All"],
      "Small-scale Land Cover": ["All"],
      "Small-scale Names And Map Reference": ["All"],
      "Small-scale Other": ["All"],
      "Small-scale Structures": ["All"],
      Thumbnails: ["All"],
    },
    Structures: {
      Shape: ["All", "XML", "ZIP"],
      National: ["All", "XML", "ZIP"],
      GDB: ["All", "XML", "ZIP"],
    },
    TopoMapVector: {
      ALL: ["All", "0", "1", "C", "H", "XML", "ZIP"],
    },
    Transportation: {
      National: ["All", "XML", "ZIP"],
      GDB: ["All", "1", "XML", "ZIP"],
      Shape: ["All", "DB", "XML", "ZIP"],
    },
    Vector: {
      AR: ["All"],
      GDB: ["All"],
      GPKG: ["All"],
      Shape: ["All"],
    },
    Unclassified: ["All"],
  };

  return datasetOptions[theme]?.[dataset] || [];
}
